import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import {
  LayoutDashboard, Users, Layers, Gift, Hash,
  MessageSquare, Settings, LogOut, Radio
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";

const navItems = [
  { path: "/", label: "Dashboard", icon: LayoutDashboard },
  { path: "/channels", label: "Kanallar", icon: Hash },
  { path: "/users", label: "Kullanicilar", icon: Users },
  { path: "/messages", label: "Mesajlar", icon: MessageSquare },
  { path: "/groups", label: "Gruplar", icon: Layers },
  { path: "/rewards", label: "Oduller", icon: Gift },
  { path: "/settings", label: "Ayarlar", icon: Settings },
];

export default function Layout() {
  const { logout, admin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="flex h-screen bg-[#0A0A0A]">
      <aside className="w-60 border-r border-[#27272A] bg-[#121212] flex flex-col shrink-0">
        <div className="p-5 flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-[#24A1DE]/10 flex items-center justify-center">
            <Radio className="w-5 h-5 text-[#24A1DE]" />
          </div>
          <span className="font-heading text-base font-bold text-white tracking-tight">TG Admin</span>
        </div>
        <Separator className="bg-[#27272A]" />
        <ScrollArea className="flex-1 px-3 py-4">
          <nav className="space-y-1" data-testid="sidebar-nav">
            {navItems.map(({ path, label, icon: Icon }) => (
              <NavLink
                key={path}
                to={path}
                end={path === "/"}
                data-testid={`nav-${path === "/" ? "dashboard" : path.slice(1)}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-150 ${
                    isActive
                      ? "bg-[#24A1DE]/10 text-[#24A1DE] border-l-2 border-[#24A1DE] pl-[10px]"
                      : "text-[#A1A1AA] hover:text-white hover:bg-[#2C2C2E]"
                  }`
                }
              >
                <Icon className="w-4 h-4 shrink-0" />
                {label}
              </NavLink>
            ))}
          </nav>
        </ScrollArea>
        <div className="p-3 border-t border-[#27272A]">
          {admin && (
            <p className="text-xs text-[#A1A1AA] px-3 mb-2 font-mono truncate">@{admin.username}</p>
          )}
          <Button
            variant="ghost"
            data-testid="logout-btn"
            className="w-full justify-start text-[#A1A1AA] hover:text-white hover:bg-[#2C2C2E] h-9"
            onClick={handleLogout}
          >
            <LogOut className="w-4 h-4 mr-2" />
            Cikis Yap
          </Button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <div className="p-6 lg:p-8 animate-fade-in">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
